import { AdminPanels } from "@/pages/admin/AdminDashboard";

export default function SuperAdminDashboard() {
  return <AdminPanels isSuper={true} />;
}
